import React from 'react';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

function Button({ children, onClick, isTableOpen, bgColor, bgColorHover, isLoading = false }) {
  return (
    <ButtonContainer
      data-panel='avisos_available_products'
      onClick={onClick}
      isTableOpen={isTableOpen}
      bgColor={bgColor}
      bgColorHover={bgColorHover}
    >
      {children}
    </ButtonContainer>
  );
}

const ButtonContainer = styled.button`
  background-color: ${({ bgColor }) => bgColor || select('lightGray')};
  border-radius: 8px;
  height: fit-content;
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
  width: 100%;
  ${({ isTableOpen }) =>
    isTableOpen &&
    css`
      border-radius: 8px 8px 0px 0px;
    `}
  :hover {
    background-color: ${({ bgColorHover }) => bgColorHover || select('grayMedium')};
  }
`;

export default Button;
